import { render, staticRenderFns } from "./BFormFilePreview.vue?vue&type=template&id=76471f0e&scoped=true"
import script from "./BFormFilePreview.vue?vue&type=script&lang=js"
export * from "./BFormFilePreview.vue?vue&type=script&lang=js"
import style0 from "./BFormFilePreview.vue?vue&type=style&index=0&id=76471f0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76471f0e",
  null
  
)

export default component.exports